var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 12 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 0H0.666667C0.298477 0 0 0.298477 0 0.666667V2.33333C0 2.70152 0.298477 3 0.666667 3H2.33333C2.70152 3 3 2.70152 3 2.33333V0.666667C3 0.298477 2.70152 0 2.33333 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0.375H5.54167C5.17348 0.375 4.875 0.673477 4.875 1.04167V1.95833C4.875 2.32652 5.17348 2.625 5.54167 2.625H11.3333C11.7015 2.625 12 2.32652 12 1.95833V1.04167C12 0.673477 11.7015 0.375 11.3333 0.375Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.5H0.666667C0.298477 4.5 0 4.79848 0 5.16667V6.83333C0 7.20152 0.298477 7.5 0.666667 7.5H2.33333C2.70152 7.5 3 7.20152 3 6.83333V5.16667C3 4.79848 2.70152 4.5 2.33333 4.5Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.875H5.54167C5.17348 4.875 4.875 5.17348 4.875 5.54167V6.45833C4.875 6.82652 5.17348 7.125 5.54167 7.125H11.3333C11.7015 7.125 12 6.82652 12 6.45833V5.54167C12 5.17348 11.7015 4.875 11.3333 4.875Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 9H0.666667C0.298477 9 0 9.29848 0 9.66667V11.3333C0 11.7015 0.298477 12 0.666667 12H2.33333C2.70152 12 3 11.7015 3 11.3333V9.66667C3 9.29848 2.70152 9 2.33333 9Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.375H5.54167C5.17348 9.375 4.875 9.67348 4.875 10.0417V10.9583C4.875 11.3265 5.17348 11.625 5.54167 11.625H11.3333C11.7015 11.625 12 11.3265 12 10.9583V10.0417C12 9.67348 11.7015 9.375 11.3333 9.375Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/ListViewIcon.4f2a692b977eaa70cfd0d5fae93a1fa3.svg";
export { ForwardRef as ReactComponent };